/**
 * @Description 在地图中不被遮挡的卡片组件
 */

import { FC } from 'react';
import cs from 'classnames';
import styles from './index.module.less';

interface NotObscuredCardInMapProps {
  [p:string]: any;
};
const NotObscuredCardInMap: FC<NotObscuredCardInMapProps> = ({
  orientationInfo,
  children,
  wrapperClassName,
  handleClickContainer
}) => {
  const { direction } = orientationInfo || {};

  return (
    <div
      onWheel={(e) => e.stopPropagation()}
      // onClick={() => handleClick({ data })}
      className={cs(
        styles.container,
        direction ? styles[direction] : styles.top,
        wrapperClassName
      )}
      onClick={() => {
        handleClickContainer && handleClickContainer();
      }}
    >
      {children}
    </div>
  );
};

export default NotObscuredCardInMap;
